import { inSessionProperties } from '../../canvas/EditorSession';
import { StateProperty } from '../../canvas/ExtendableStore';
import { Package, PackageHost } from '../../Container';
import { inConcealCommands } from './ConcealCommands';
import { ConcealMechanics } from './ConcealMechanics';
import { ConcealmentIndex } from './ConcealmentIndex';
import { ConcealmentInfo, DefaultConcealmentInfo } from './ConcealmentInfo';

export class ConcealPackage implements Package {

    public install = (host: PackageHost) => host
        .register(ConcealMechanics, 'singleton')
        .register(ConcealmentIndex, 'singleton')
        .plug(inConcealCommands())
        .plug(inSessionProperties(StateProperty.variable(ConcealmentInfo, DefaultConcealmentInfo())))
        .start(ConcealmentIndex, ConcealMechanics)
        ;
}
